// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'field-cursor';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2.094 4.218h13.812s1.063 0 1.063 1.063v7.437s0 1.063-1.063 1.063H2.094s-1.063 0-1.063-1.063V5.281s0-1.063 1.063-1.063zm3.187 7.437V6.343m-1.062 0h2.125m-2.125 5.312h2.125'
  />
);

export const viewBox = '0 0 18 18';
